/** Shown when an attachment cannot be previewed in the browser (e.g. in carousel document fallback). */
export const DOCUMENT_HINT = 'This file cannot be previewed in the browser.';

/** Default accept string for file inputs: images, PDF, Word, Excel, PowerPoint, audio. */
export const DEFAULT_FILE_ACCEPT =
  'image/*,audio/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation';
